export default "__VITE_ASSET__Dxys_shF__"